document.addEventListener("DOMContentLoaded", function () {
  

 function setInstallment(minVal, qtyParcel, price) {

var priceElement = document.querySelector('span[data-product-price]');
if (priceElement) {
    var priceText = priceElement.textContent.trim();
    // Remover 'R$' e substituir ',' por '.' e remover pontos de milhares
    var priceValue = parseFloat(priceText.replace('R$', '').replace(/\./g, '').replace(',', '.'));

    // Converter para centavos
    var priceInCents = Math.round(priceValue * 100);
    console.log("preço em centavos: ", priceInCents);  // Exemplo de saída correta para "R$ 1.019,80" será 101980
} else {
    console.log("Elemento não encontrado");
}

   price = priceInCents;
   
    console.log("muda preço")
    for (var i = window.parcelNumber; i > 0; i--) {
      console.log(i)
      var parcelVal = price / i;
      if (minVal <= parcelVal) {
         console.log("muda preço2")
        var elements = document.querySelectorAll(".installment-price span");
        var formattedMoney = (parcelVal / 100).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        console.log(elements)
        console.log(formattedMoney)
        var htmlContent =
          "ou até " +
          i +
          "x de " +
          formattedMoney +
          ' <span class="juros">sem juros</span>';

        elements.forEach(function (element) {
          element.innerHTML = htmlContent;
        });
        break;
      }
    }
  };


  
  function updateInstallmentPrice(times, price, withInterest = false) {
    const installmentElement = document.querySelector('.installment-price span');
    
    if (installmentElement) {

          for (var i = window.parcelNumber; i > 0; i--) {
                var parcelVal = price / i;
               if (minVal <= parcelVal) {

               }
             }
        let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price);
        
        installmentElement.textContent = `ou até ${times}xX de ${formattedPrice}`;

        const interestSpan = installmentElement.querySelector('.juros');
        if (withInterest) {
            if (!interestSpan) {
                // Se o <span class="juros"> não existe, criamos e anexamos ao elemento.
                const newInterestSpan = document.createElement('span');
                newInterestSpan.className = 'juros';
                newInterestSpan.textContent = ' com juros';
                installmentElement.appendChild(newInterestSpan);
            } else {
                interestSpan.textContent = ' com juros';
            }
        } else {
            if (interestSpan) {
                interestSpan.textContent = ' sem juros';
            } else {
                // Se o <span class="juros"> não existe, criamos e anexamos ao elemento.
                const newInterestSpan = document.createElement('span');
                newInterestSpan.className = 'juros';
                newInterestSpan.textContent = ' sem juros';
                installmentElement.appendChild(newInterestSpan);
            }
        }
    } else {
        console.error('Elemento de parcelamento não encontrado.');
    }
}



  document.querySelectorAll('.variant-input input[type="radio"]').forEach(function (radio) {
      radio.addEventListener("change", function (e) {
        if (e.target.checked) {
          console.log("A variante selecionada mudou para:", e.target.value);
      setTimeout(function() {        
      setInstallment(
          window.minParcelamento,
          window.parcelNumber,
          window.localVariant.price
        );
         }, 100); // 100ms de atraso
          
        }
      });
    });

  
document.querySelectorAll('.addMoreProducts').forEach(function (div) {
    div.addEventListener("click", function (e) {
        console.log("Div .addMoreProducts foi clicada, opção selecionada mudou para:");
      setTimeout(function() {        
      setInstallment(
          window.minParcelamento,
          window.parcelNumber,
          window.localVariant.price
        );
         }, 100); // 100ms de atraso
    });
});



});
